<form [formGroup]="form" class="h-full" (submit)="onSubmit()">
  <div class="px-4 md:pl-12 md:pr-0 flex items-center justify-center md:justify-start h-full">
    <div class="w-full max-w-[310px] md:w-auto md:max-w-none">
      <div>
        <p>
          <span class="sign strong mr-1">Choose</span>&nbsp;
          <span class="sign light">Your Password</span>
        </p>
      </div>

      <div
        [ngClass]="{
          'has-error':
            formNewPaswordControl.touched && formNewPaswordControl.invalid
        }"
        class="sign-in-input relative w-full md:w-[310px] h-[60px] mt-8"
      >
        <div class="sign-in-icon">
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 10C16 8.897 15.103 8 14 8H13V5C13 2.243 10.757 0 8 0C5.243 0 3 2.243 3 5V8H2C0.897 8 0 8.897 0 10V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V10ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5V8H5V5Z"
              fill="#333333"
            />
          </svg>
        </div>
        <input
          type="password"
          formControlName="newPassword"
          placeholder="New Password"
          autocomplete="off"
          aria-label="New Password"
        />
        <div *ngIf="formNewPaswordControl.valid" class="sign-in-password-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
              stroke="#28A745"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.75 12L10.58 14.83L16.25 9.17004"
              stroke="#28A745"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <div
        [ngClass]="{
          error: formNewPaswordControl.touched && formNewPaswordControl.invalid
        }"
        class="mt-2 hint"
        *ngIf="formNewPaswordControl.invalid"
      >
        <p>Password must contain:</p>
        <p>&#8226; Uppercase, lowercase and numbers.</p>
        <p>&#8226; Between 8 to 32 characters.</p>
      </div>
      <div
        [ngClass]="{
          'has-error':
            formNewPasswordRetype.touched && formNewPasswordRetype.invalid
        }"
        class="sign-in-input relative w-full md:w-[310px] h-[60px] mt-4"
      >
        <div class="sign-in-icon">
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 10C16 8.897 15.103 8 14 8H13V5C13 2.243 10.757 0 8 0C5.243 0 3 2.243 3 5V8H2C0.897 8 0 8.897 0 10V18C0 19.103 0.897 20 2 20H14C15.103 20 16 19.103 16 18V10ZM5 5C5 3.346 6.346 2 8 2C9.654 2 11 3.346 11 5V8H5V5Z"
              fill="#333333"
            />
          </svg>
        </div>
        <input
          #password
          type="password"
          formControlName="newPasswordRetype"
          placeholder="Confirm Password"
          autocomplete="off"
          aria-label="password"
        />
        <div
          *ngIf="formNewPasswordRetype.valid && formNewPaswordControl.value"
          class="sign-in-password-icon"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
              stroke="#28A745"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M7.75 12L10.58 14.83L16.25 9.17004"
              stroke="#28A745"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
      <p
        *ngIf="
          formNewPasswordRetype.touched &&
          formNewPasswordRetype.hasError('mustMatch')
        "
        class="retype-error"
      >
        Password doesn't match
      </p>
      <p *ngIf="errorMessage" class="retype-error mt-1">{{ errorMessage }}</p>

      <button
        [disabled]="!form.valid || isRecentlyUsed"
        class="login-btn flex justify-center items-center block w-full md:w-[310px] h-[60px] mt-4"
      >
        <svg
          *ngIf="loading; else notLoading"
          class="animate-spin"
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_914_5279" fill="white">
            <path
              d="M15 1.25168e-06C17.9667 1.122e-06 20.8668 0.879735 23.3336 2.52796C25.8003 4.17618 27.7229 6.51886 28.8582 9.25975C29.9935 12.0006 30.2906 15.0166 29.7118 17.9264C29.133 20.8361 27.7044 23.5088 25.6066 25.6066C23.5088 27.7044 20.8361 29.133 17.9264 29.7118C15.0166 30.2906 12.0006 29.9935 9.25975 28.8582C6.51886 27.7229 4.17618 25.8003 2.52796 23.3336C0.879734 20.8668 -5.61369e-07 17.9667 -6.55671e-07 15L3 15C3 17.3734 3.70379 19.6935 5.02236 21.6668C6.34094 23.6402 8.21509 25.1783 10.4078 26.0866C12.6005 26.9948 15.0133 27.2324 17.3411 26.7694C19.6689 26.3064 21.8071 25.1635 23.4853 23.4853C25.1635 21.8071 26.3064 19.6689 26.7694 17.3411C27.2324 15.0133 26.9948 12.6005 26.0866 10.4078C25.1783 8.21509 23.6402 6.34094 21.6668 5.02236C19.6935 3.70379 17.3734 3 15 3L15 1.25168e-06Z"
            />
          </mask>
          <path
            d="M15 1.25168e-06C17.9667 1.122e-06 20.8668 0.879735 23.3336 2.52796C25.8003 4.17618 27.7229 6.51886 28.8582 9.25975C29.9935 12.0006 30.2906 15.0166 29.7118 17.9264C29.133 20.8361 27.7044 23.5088 25.6066 25.6066C23.5088 27.7044 20.8361 29.133 17.9264 29.7118C15.0166 30.2906 12.0006 29.9935 9.25975 28.8582C6.51886 27.7229 4.17618 25.8003 2.52796 23.3336C0.879734 20.8668 -5.61369e-07 17.9667 -6.55671e-07 15L3 15C3 17.3734 3.70379 19.6935 5.02236 21.6668C6.34094 23.6402 8.21509 25.1783 10.4078 26.0866C12.6005 26.9948 15.0133 27.2324 17.3411 26.7694C19.6689 26.3064 21.8071 25.1635 23.4853 23.4853C25.1635 21.8071 26.3064 19.6689 26.7694 17.3411C27.2324 15.0133 26.9948 12.6005 26.0866 10.4078C25.1783 8.21509 23.6402 6.34094 21.6668 5.02236C19.6935 3.70379 17.3734 3 15 3L15 1.25168e-06Z"
            fill="#7252AE"
            stroke="#7252AE"
            stroke-width="2"
            mask="url(#path-1-inside-1_914_5279)"
          />
        </svg>
        <ng-template #notLoading>Save</ng-template>
      </button>
    </div>
  </div>
</form>
